// extracted by mini-css-extract-plugin
export default {"link":"styles_link__Y6ZtF","bold":"styles_bold__Vta18","primary":"styles_primary__6ebpQ","secondary":"styles_secondary__19fx8","warning":"styles_warning__-9Mfs"};